// extracted by mini-css-extract-plugin
var _1 = "#68914d";
var _2 = "#9cc681";
var _3 = "#8ab46f";
var _4 = "8px";
var _5 = "6px";
var _6 = "8px";
var _7 = "0 1px 1px 0 rgba(0,0,0,.02) inset";
var _8 = "0 8px 8px -4px rgba(0,0,0,.03),0 16px 24px -4px rgba(0,0,0,.08)";
var _9 = "10px";
var _a = "card___WddNT";
var _b = "#e8e8e8";
var _c = "16px 24px";
var _d = "#38aa73";
var _e = "#956c22";
var _f = "#2988bd";
var _10 = "#eee";
var _11 = "#c4842d";
var _12 = "#b8567c";
var _13 = "#8b6e4e";
var _14 = "#5889c2";
var _15 = "#4e8a8a";
var _16 = "#6a8a3e";
var _17 = "#7b5ea7";
var _18 = "#4a6fa5";
var _19 = "#3a8a6e";
var _1a = "#c25b4e";
var _1b = "#fafbfc";
var _1c = "#1e3050";
var _1d = "#293d62";
var _1e = "#fafbfc";
var _1f = "rgba(0,0,0,.12)";
var _20 = "#d9d9d9";
var _21 = "rgba(5,5,5,.1)";
var _22 = "#eaf2fc";
var _23 = "rgba(0,0,0,.65)";
var _24 = "#ebebeb";
var _25 = "#068467";
var _26 = "rgba(6,132,103,.1)";
var _27 = "#dc4949";
var _28 = "rgba(220,73,73,.1)";
var _29 = "#787c81";
var _2a = "#d6d9dc";
var _2b = "#f3f5f7";
var _2c = "#73c9b2";
var _2d = "linear-gradient(180deg, #73C9B2 0%, #B8E7DA 100%)";
var _2e = "#b8e7da";
var _2f = "#5357f8";
var _30 = "rgb(14.3921787709,19.9877094972,245.2078212291)";
var _31 = "rgb(249.6189944134,249.7441340782,254.7810055866)";
var _32 = "#f7f8f9";
var _33 = "#edeeef";
var _34 = "#7b8996";
var _35 = "#ededed";
var _36 = "#f4f5f7";
var _37 = "#fbfbfc";
var _38 = "rgba(0,0,0,.75)";
var _39 = "rgba(171.2567039106,172.4612273574,220.9432960894,.95)";
var _3a = "rgba(0,0,0,.3)";
var _3b = "rgba(0,0,0,.5)";
var _3c = "rgba(0,0,0,.4)";
var _3d = "rgba(0,0,0,.95)";
var _3e = "rgba(0,0,0,.65)";
var _3f = "rgba(0,0,0,.85)";
var _40 = "20px";
var _41 = "contentOverlay___PC3Op";
var _42 = "cta___LRHkh";
var _43 = "#f41e28";
var _44 = "1063px";
var _45 = "rgba(227,89,86,.2)";
var _46 = "#e35956";
var _47 = "16px 24px";
var _48 = "28px";
var _49 = "32px";
var _4a = "18px";
var _4b = "14px";
var _4c = "14px";
var _4d = "15px";
var _4e = "12.6px";
var _4f = "11px";
var _50 = "20px";
var _51 = "28px";
var _52 = "700";
var _53 = "200";
var _54 = "300";
var _55 = "500";
var _56 = "400";
var _57 = "600";
var _58 = "hsla(0,0%,100%,.2)";
var _59 = "#ccc";
var _5a = "header____5H7K";
var _5b = "49px";
var _5c = "headerWrap___Ba5nI";
var _5d = "5px";
var _5e = "#5357f8";
var _5f = "rgba(0,0,0,.4)";
var _60 = "logo___pRrcP";
var _61 = "#fafafa";
var _62 = "hsla(0,0%,100%,.9)";
var _63 = "root___AbseZ";
var _64 = "15px";
var _65 = "20px";
var _66 = "24px";
var _67 = "hsla(0,0%,100%,.6)";
var _68 = "#7e7eff";
var _69 = "hsla(0,0%,100%,.7)";
var _6a = "hsla(0,0%,100%,.3)";
var _6b = "hsla(0,0%,100%,.575)";
var _6c = "60px";
var _6d = "208px";
var _6e = "rgba(82,196,26,.2)";
var _6f = "#52c41a";
var _70 = "12px";
var _71 = "20px";
var _72 = "rgba(250,173,20,.2)";
var _73 = "#faad14";
var _74 = "#fff";
var _75 = "hsla(0,0%,100%,.2)";
export { _1 as "actionButtonColorDark", _2 as "actionButtonColorLight", _3 as "actionButtonColorMedium", _4 as "borderRadiusCard", _5 as "borderRadiusMain", _6 as "borderRadiusSurface", _7 as "boxShadowInnerXs", _8 as "boxShadowXl", _9 as "btnRightMargin", _a as "card", _b as "cardBorderColor", _c as "cardPadding", _d as "changeSetCompletedColor", _e as "changeSetManuallyChangesProposed", _f as "changeSetScheduledChangesProposed", _10 as "chipBackground", _11 as "colorAccentAmber", _12 as "colorAccentBerry", _13 as "colorAccentBrown", _14 as "colorAccentCornflower", _15 as "colorAccentCyan", _16 as "colorAccentOlive", _17 as "colorAccentPurple", _18 as "colorAccentSteelBlue", _19 as "colorAccentTeal", _1a as "colorAccentTerracotta", _1b as "colorBackgroundMain", _1c as "colorBackgroundSidebar", _1d as "colorBackgroundSidebarHover", _1e as "colorBackgroundTabs", _1f as "colorBorderContainer", _20 as "colorBorderMain", _21 as "colorBorderSecondary", _22 as "colorDeltaCyanBlueBg", _23 as "colorDeltaGray", _24 as "colorDeltaGrayBg", _25 as "colorDeltaGreen", _26 as "colorDeltaGreenBg", _27 as "colorDeltaRed", _28 as "colorDeltaRedBg", _29 as "colorDetailsFieldText", _2a as "colorDetailsIcon", _2b as "colorDetailsTagBg", _2c as "colorMint", _2d as "colorMintGradient", _2e as "colorMintLight", _2f as "colorPrimary", _30 as "colorPrimaryHover", _31 as "colorPrimaryLightened", _32 as "colorTableHeadBg", _33 as "colorTableHeadBgHover", _34 as "colorTableHeadSubtitle", _35 as "colorTableRowBorder", _36 as "colorTableTextBg", _37 as "colorTableTotalRowBg", _38 as "colorTextBase", _39 as "colorTextDisabled", _3a as "colorTextExtraLight", _3b as "colorTextLight", _3c as "colorTextLighter", _3d as "colorTextMainHeading", _3e as "colorTextMuted", _3f as "colorTextPrimary", _40 as "contentHorizPadding", _41 as "contentOverlay", _42 as "cta", _43 as "dangerColor", _44 as "dashboardPdfContentWidth", _45 as "errorBackcolor", _46 as "errorColor", _47 as "filterPanelPadding", _48 as "filtersDefaultHeight", _49 as "filtersTallHeight", _4a as "fontSizeLarge", _4b as "fontSizeMain", _4c as "fontSizeMedium", _4d as "fontSizePlus", _4e as "fontSizeSmaller", _4f as "fontSizeSmallest", _50 as "fontSizeXLarge", _51 as "fontSizeXxLarge", _52 as "fontWeightBold", _53 as "fontWeightExtraLight", _54 as "fontWeightLight", _55 as "fontWeightMediumBold", _56 as "fontWeightNormal", _57 as "fontWeightSemiBold", _58 as "ghostWhite", _59 as "grayBackgroundColor", _5a as "header", _5b as "headerHeight", _5c as "headerWrap", _5d as "iconHorizontalMargin", _5e as "linkColor", _5f as "linkColorMuted", _60 as "logo", _61 as "popoverHeaderColor", _62 as "popoverMaskColor", _63 as "root", _64 as "rowPadding", _65 as "ruleInnerGutters", _66 as "ruleSideGutters", _67 as "sideMenuIconColor", _68 as "sideMenuIconSelectedColor", _69 as "sideMenuItemColor", _6a as "sideMenuScrollbarThumbColor", _6b as "sideMenuSubmenuItemColor", _6c as "sidebarCollapsedWidth", _6d as "sidebarWidth", _6e as "successBackcolor", _6f as "successColor", _70 as "tableHeaderVerticalPadding", _71 as "tableHorizPadding", _72 as "warningBackcolor", _73 as "warningColor", _74 as "whiteColor", _75 as "whiteDividerColor" }
